import PropTypes from 'prop-types';

export const EodManifestResultPropType = PropTypes.shape({
  status: PropTypes.string,
  scanFormId: PropTypes.string,
  shipFromId: PropTypes.number,
  shipmentCount: PropTypes.number,
  segmentIndex: PropTypes.number,
  hasSucceeded: PropTypes.bool,
  exceptionType: PropTypes.number,
});

/**
 * @typedef {object} EODManifestResultPropType
 * @property {string} status
 * @property {string} scanFormId
 * @property {number} shipFromId
 * @property {number} shipmentCount
 * @property {number} segmentIndex
 * @property {boolean} hasSucceeded
 * @property {number} exceptionType
 */
